export default __webpack_public_path__ + "static/media/review-the-competitive.a7399f0b.svg";